// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"0a0d6285","223":"0a0d6285"}[chunkId] + ".chunk.css";
};